import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ifProp, prop } from 'styled-tools';
import { withRouter } from 'react-router-dom';

const StyledButton = styled.button`
  cursor: ${ifProp('disabled', 'auto', 'pointer')};
  outline: 0;
  border: 0;
  background: url(${prop('src')}) no-repeat center;  
  background-size: contain;
  white-space: nowrap;
  flex-direction: column;
  justify-content: center;
  height: ${ifProp('height', prop('height'), 'auto')};
  width: ${ifProp('width', prop('width'), 'auto')};
  box-shadow: ${ifProp('shadow', '3px 3px 5px black', 'none')};
`;

const Button = ({ onClick, to, stampNumber, stampTemplate, disabled, color, src, width, height, shadow, ...props }) => {
  const { history } = props;
  const newOnClick = (e) => {
    if (to) {
      history.push(to, {stampNumber: stampNumber, stampTemplate: stampTemplate});
    }
    return onClick(e);
  }
  return (
    <StyledButton
      src={src}
      onClick={newOnClick}
      disabled={disabled}
      color={color}
      height={height}
      width={width}
      shadow={shadow}
      {...props}
    />
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  to: PropTypes.string,
  stampNumber: PropTypes.number,
  stampTemplate: PropTypes.string,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  fullWidth: PropTypes.bool,
  src: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  shadow: PropTypes.bool
};

Button.defaultProps = {
  onClick: () => {},
  to: null,
  stampNumber: null,
  stampTemplate: '',
  disabled: false,
  color: null,
  fullWidth: false,
  src: null,
  width: null,
  height: null,
  shadow: false
};

export default withRouter(Button);
